import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

const DISMISS_KEY = 'pwa_dismissed_at';
const DISMISS_DURATION_MS = 14 * 24 * 60 * 60 * 1000; // 14 days

const wasDismissedRecently = () => {
  const ts = localStorage.getItem(DISMISS_KEY);
  if (!ts) return false;
  return Date.now() - parseInt(ts, 10) < DISMISS_DURATION_MS;
};

export const useInstallPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    // Never show inside a native app
    if (Capacitor.isNativePlatform()) return;

    // Already installed
    if (window.matchMedia('(display-mode: standalone)').matches) return;

    // Dismissed recently
    if (wasDismissedRecently()) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setShowPrompt(false);
    setDeferredPrompt(null);
  };

  const dismissPrompt = () => {
    localStorage.setItem(DISMISS_KEY, Date.now().toString());
    setShowPrompt(false);
  };

  return { showPrompt, handleInstall, dismissPrompt };
};
